import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderSchedulingChangeRequests: build.query<
      GetV2ProviderSchedulingChangeRequestsApiResponse,
      GetV2ProviderSchedulingChangeRequestsApiArg
    >({
      query: () => ({ url: `/v2/provider/scheduling/change-requests` }),
    }),
    postV2ProviderSchedulingChangeRequestsByRequestIdApprove: build.mutation<
      PostV2ProviderSchedulingChangeRequestsByRequestIdApproveApiResponse,
      PostV2ProviderSchedulingChangeRequestsByRequestIdApproveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/change-requests/${queryArg.requestId}/approve`,
        method: "POST",
      }),
    }),
    postV2ProviderSchedulingChangeRequestsByRequestIdDecline: build.mutation<
      PostV2ProviderSchedulingChangeRequestsByRequestIdDeclineApiResponse,
      PostV2ProviderSchedulingChangeRequestsByRequestIdDeclineApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/change-requests/${queryArg.requestId}/decline`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderSchedulingChangeRequestsApiResponse =
  /** status 200 OK */ ChangeRequestListResponse;
export type GetV2ProviderSchedulingChangeRequestsApiArg = void;
export type PostV2ProviderSchedulingChangeRequestsByRequestIdApproveApiResponse =
  /** status 200 OK */ ChangeRequestDecisionResponse;
export type PostV2ProviderSchedulingChangeRequestsByRequestIdApproveApiArg = {
  requestId: string;
};
export type PostV2ProviderSchedulingChangeRequestsByRequestIdDeclineApiResponse =
  /** status 200 OK */ ChangeRequestDecisionResponse;
export type PostV2ProviderSchedulingChangeRequestsByRequestIdDeclineApiArg = {
  requestId: string;
};
export type ChangeRequestSchema = {
  appointment_change_request_id: string;
  appointment_id: string;
  /** Set for self-scheduled bookings */
  booking_prospect_id?: string | null;
  /** The appointment's current (unchanged) start */
  current_start_time?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Confirmation mode stamped when the request was filed */
  governing_mode: string;
  provider_id?: string | null;
  /** reschedule (cancel reserved) */
  request_type: string;
  requested_at?: string | null;
  /** The requested new start (reschedules) */
  requested_start_time?: string | null;
  /** Who asked (prospect contact or patient name) */
  requester_name?: string | null;
  /** pending|approved|declined|superseded */
  status: string;
};
export type ChangeRequestListResponse = {
  items: ChangeRequestSchema[];
  /** Count of items in this page */
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ChangeRequestSchema2 = {
  appointment_change_request_id: string;
  appointment_id: string;
  /** Set for self-scheduled bookings */
  booking_prospect_id?: string | null;
  /** The appointment's current (unchanged) start */
  current_start_time?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Confirmation mode stamped when the request was filed */
  governing_mode: string;
  provider_id?: string | null;
  /** reschedule (cancel reserved) */
  request_type: string;
  requested_at?: string | null;
  /** The requested new start (reschedules) */
  requested_start_time?: string | null;
  /** Who asked (prospect contact or patient name) */
  requester_name?: string | null;
  /** pending|approved|declined|superseded */
  status: string;
};
export type ChangeRequestDecisionResponse = {
  request: ChangeRequestSchema2;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
